<!-- 预定支出明细 -->
<template>
  <div class="container">
    <div class="title">
      <el-radio-group @change="search" v-model="filterCriteria.balanceTypes">
        <el-radio v-for="item in radioList" :value="item.value" :key="item.label" :label="item.value">{{ item.label
          }}</el-radio>
      </el-radio-group>
      <div style="display:flex;align-items:center;margin-left: auto;">
        <el-button @click="reset" style="color:#ED7046;background-color: #F7E1D4;" size="small">重置</el-button>
        <el-button @click="search" style="color:#ED7046;background-color: #F7E1D4;" size="small">搜索</el-button>
      </div>
    </div>
    <div class="mainFooter">
      <div class="left">查询关键词：</div>
      <el-input size="small" v-model="filterCriteria.orderNumber" style="width: 1.5rem; margin-right: 0.1rem"
        placeholder="请输入订单编号"></el-input>
      <el-input size="small" v-model="filterCriteria.planId" style="width: 1.5rem; margin-right: 0.1rem"
        placeholder="请输入团号"></el-input>
      <el-input size="small" v-model="filterCriteria.createName" style="width: 1.5rem; margin-right: 0.1rem"
        placeholder="请输入下单人"></el-input>
      <el-input size="small" v-model="filterCriteria.describe" style="width: 1.5rem; margin-right: 0.1rem"
        placeholder="请输入说明"></el-input>
      <el-select @change="search" style="margin-right: 0.1rem; width: 1.7rem" size="small"
        v-model="filterCriteria.source" placeholder="请选择支付渠道">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="filterCriteria.price" size="small" type="number" style="width: 1.5rem; margin-right: 0.1rem"
        placeholder="请输入支付金额"></el-input>
      <p style="font-size: 0.1rem">消费时间：</p>
      <el-date-picker @change="search" value-format="yyyy-MM-dd" size="small" v-model="filterCriteria.dateArr"
        style="margin-right: 0.1rem" type="daterange" range-separator="至" start-placeholder="操作开始日期"
        end-placeholder="操作结束日期">
      </el-date-picker>
    </div>
    <p v-if="filterCriteria.balanceTypes == null" class="p3">
      符合条件共：实际收款金额（ <span>{{ (Number(balanceTotalObj.income) - Number(balanceTotalObj.refuse)).toFixed(2) }}¥</span>
      ）收款金额（ <span>{{ Number(balanceTotalObj.income) }}¥</span> ）收款支出金额（ <span>{{ Number(balanceTotalObj.refuse)
        }}¥</span> ）
    </p>
    <p v-else-if="filterCriteria.balanceTypes == '1'" class="p3">
      符合条件共：收款金额（
      <span>{{ Number(balanceTotalObj.income) }}¥</span> ）
    </p>
    <p v-else class="p3">
      符合条件共：退款金额（ <span>{{ Number(balanceTotalObj.refuse) }}¥</span> ）
    </p>
    <el-table border header-align="center" :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="date" label="收款时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | dateFormatHms }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="orderNumber" label="订单号">
      </el-table-column>
      <el-table-column align="center" prop="planId" label="团号">
      </el-table-column>
      <el-table-column align="center" prop="createName" label="收款人">
      </el-table-column>
      <el-table-column align="center" prop="describe" label="说明">
      </el-table-column>
      <el-table-column align="center" label="收款渠道">
        <template slot-scope="scope">
          {{ payMode[scope.row.source] }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="收款金额">
        <template slot-scope="scope">
          {{ scope.row.price + '¥' }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { walletMixing } from './walletMixing'
export default {
  mixins: [walletMixing],
  props: {
    tableData: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      payMode: {
        0: '微信 ',
        1: '支付宝',
        2: '余额',
        3: '线下转账'
      },
      radioList: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "1",
          label: "收款",
        },
        {
          value: "9,13",
          label: "支出",
        },
      ],
      options: [
        {
          value: "1",
          label: "支付宝",
        },
        {
          value: "2",
          label: "微信",
        },
        {
          value: "3",
          label: "余额",
        },
        {
          value: "4",
          label: "线下",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.filterCriteria.balanceType = 2
  },
};
</script>
<style lang="scss" scoped>
/* 选中后的字体颜色 */
/deep/.el-radio__input.is-checked+.el-radio__label {
  color: #CE7341 !important;
}

/* 选中后小圆点的颜色 */
/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #CE7341 !important;
  border-color: #CE7341 !important;
}


.container {
  .title {
    margin-bottom: 0.1rem;
    display: flex;
    align-items: center;
  }

  .mainFooter {
    display: flex;
    align-items: center;
    margin-bottom: 0.24rem;
    background-color: #f3f3f3;
    padding: 0.15rem;

    .left {
      font-size: 0.12rem;
    }
  }

  .p3 {
    margin-bottom: 0.24rem;

    span {
      color: #dc7039;
      font-weight: bold;
    }
  }
}
</style>